export default __webpack_public_path__ + "static/media/screen2.c69c4f90.png";